import { render, staticRenderFns } from "./AssignedEventsList.vue?vue&type=template&id=4f74969f&"
import script from "./AssignedEventsList.vue?vue&type=script&lang=js&"
export * from "./AssignedEventsList.vue?vue&type=script&lang=js&"
import style0 from "./AssignedEventsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports